import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue, push, set } from "firebase/database";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFunctions } from "firebase/functions"; // ✅ correct import

const firebaseConfig = {
    apiKey: "AIzaSyAYyYxAwSfBysHHjbSMYC2W5V8K5gVBi4w",
    authDomain: "interview-buster-id.firebaseapp.com",
    databaseURL: "https://interview-buster-id-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "interview-buster-id",
    storageBucket: "interview-buster-id.firebasestorage.app",
    messagingSenderId: "1052192794752",
    appId: "1:1052192794752:web:cda631c607d6c701685e65",
    measurementId: "G-FBB1XHG4J6"
};

// ✅ Initialize Firebase App
const app = initializeApp(firebaseConfig);

// ✅ Services
export const db = getDatabase(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const functions = getFunctions(app); // ✅ this is the initialized instance!

// ✅ Export helpers
export { ref, onValue, push, set };
